import React from "react";

const Subfooter = () => {
  const array_social = [
    {
      id: "1",
      icon: "fa-brands fa-instagram",
      link: "https://www.instagram.com/luisytayofficial/",
    },
    {
      id: "2",
      icon: "fa-brands fa-youtube",
      link: "https://www.youtube.com/@luisytayler",
    },
    {
      id: "3",
      icon: "fa-brands fa-tiktok",
      link: "https://www.tiktok.com/@luisytayofficial",
    },
  ];
  return (
    <div className="subfooter">
      <div className="t-container t-flex-op1">
        <span className="copyright">
          Copyright © 2025 Luis y Tay | All Rights Reserved .Website Designed by{" "}
          <a
            href="https://toollyapp.com"
            target="_blank"
            rel="noreferrer"
            className="enlace"
          >
            Toollyapp.com
          </a>
        </span>
        <div className="social-media t-flex-op1">
          {array_social.map((info) => (
            <a
              key={info?.id}
              href={info?.link}
              target="_blank"
              rel="noreferrer"
            >
              <i className={info?.icon}></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Subfooter;
